<div class="content">
    <h1 mat-dialog-title>{{wording.title}}</h1>
    <div mat-dialog-content>
        <text class="input"
              [fieldConfig]="mailConfig.toConfig"
              (onBlur)="editMailEvent()"
              (onKeyPress)="editMailEvent()">
        </text>

        <text class="input"
              [fieldConfig]="mailConfig.ccConfig"
              (onBlur)="editMailEvent()"
              (onKeyPress)="editMailEvent()">
        </text>

        <text class="input"
              [fieldConfig]="mailConfig.subjectConfig"
              (onBlur)="editMailEvent()"
              (onKeyPress)="editMailEvent()">
        </text>

        <label>{{wording.body}}</label><br>
        <div [innerHtml]="mailData.body" class="mailBody" contenteditable="true" (input)="editMail($event)"></div>

    </div>
    <div mat-dialog-actions align="end">
        <btn (onClick)="cancel()" [label]="wording.cancel" type="actionLink"></btn>
        <btn (onClick)="send()" [label]="wording.send" type="actionPrincipal"></btn>
    </div>
</div>

